module.exports = __webpack_public_path__ + "static/img/229_TO8_1973.8514c51.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/229_TO8_1973.jpg
// module id = T5FQ
// module chunks = 0